import { Car, UserPlus, Wrench } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Huangguoshu Waterfall",
  description: "Witness the majesty of Asia's largest waterfall. A private guided trek through lush karst landscapes and hidden water curtain caves.",
  icon: Car
}, {
  title: "Miao Village Immersion",
  description: "Step into the world's largest Miao settlement. Experience silver-smithing traditions, ancient songs, and authentic ethnic hospitality.",
  icon: UserPlus
}, {
  title: "Wanfenglin Peaks",
  description: "Explore the 'Forest of Ten Thousand Peaks' by private vehicle or bicycle. A breathtaking panorama of limestone formations and rice paddies.",
  icon: Wrench
}];
export default function Services() {
  return <section data-section-id="224847" id="curated-expeditions" className="w-full bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold text-primary md:text-4xl">
            Curated Expeditions
          </h2>
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group rounded-xl border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-accent text-secondary transition-colors duration-300 group-hover:bg-accent/80">
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="font-default text-2xl font-bold text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-default text-base leading-relaxed text-foreground/80">
                    {service.description}
                  </CardDescription>
                  <div className="mt-4 flex items-center gap-1">
                    <span className="text-xs font-bold uppercase tracking-wider text-secondary">Starting From</span>
                    <span className="text-lg font-bold text-secondary">$299</span>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}